import React from 'react';

import ColoredCell from './ColoredCell';

const coloredCellFactory = (CustomFormatter, ellipsis) => (props) =>
    <ColoredCell {...props} ellipsis={ellipsis} CustomFormatter={CustomFormatter}/>;

export default coloredCellFactory;
